/**
 * Return true if is from seo funnel
 */
export function isFromSeoFunnel(query: Record<string, string>) {
  return query.seo !== undefined && query.seo !== 'false';
}
